import {Extension, textInputRule, textPasteRule} from '@tiptap/core';

const Symbols = {
    emDash: {
        char: '—',
        pasteRegex: /(?:[^-]|^)(--) /g,
        inputRegex: /(?:[^-]|^)(--) $/,
    },
    arrowRight: {
        char: '→',
        pasteRegex: /(->) /g,
        inputRegex: /-> $/,
    },
    arrowLeft: {
        char: '←',
        pasteRegex: /(<-) /g,
        inputRegex: /<- $/,
    },
    leftDoubleAngleQuote: {
        char: '«',
        pasteRegex: /(<<) /g,
        inputRegex: /<< $/,
    },
    rightDoubleAngleQuote: {
        char: '»',
        pasteRegex: /(>>) /g,
        inputRegex: />> $/,
    },
} as const;

export const TimeWebkitTypographyExtension = Extension.create({
    addInputRules() {
        return Object.values(Symbols).map(({char, inputRegex}) => textInputRule({
            find: inputRegex,
            replace: char,
        }));
    },
    addPasteRules() {
        return Object.values(Symbols).map(({char, pasteRegex}) => textPasteRule({
            find: pasteRegex,
            replace: char,
        }));
    },
});
